var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H12.01M11 11H12V15H13M10.24 1.95696L1.81802 16.017C1.64449 16.3177 1.5527 16.6585 1.55177 17.0057C1.55083 17.3529 1.64078 17.6943 1.81268 17.9959C1.98458 18.2975 2.23244 18.5489 2.53162 18.7251C2.83079 18.9012 3.17086 18.996 3.51802 19H20.363C20.7102 18.996 21.0502 18.9012 21.3494 18.7251C21.6486 18.5489 21.8965 18.2975 22.0684 17.9959C22.2403 17.6943 22.3302 17.3529 22.3293 17.0057C22.3283 16.6585 22.2365 16.3177 22.063 16.017L13.64 1.95696C13.4627 1.66495 13.2131 1.42355 12.9153 1.25602C12.6176 1.08849 12.2817 1.00049 11.94 1.00049C11.5984 1.00049 11.2625 1.08849 10.9647 1.25602C10.667 1.42355 10.4174 1.66495 10.24 1.95696Z",
    stroke: "#D52F3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningicon);
export default __webpack_public_path__ + "static/media/warningicon.99e50b2d3d242c2a58cc2a52ab0e9489.svg";
export { ForwardRef as ReactComponent };